<script setup lang="ts">
import ElementalsListControls from '../../components/ElementalsListControls/index.vue'
import RecentElementals from '../../components/RecentElementals/index.vue'
import ElementalViewComponent from '../../components/ElementalView/index.vue'
import { ElementalTypeEnum } from '~~/src/types/elemental'
import { useElementalListsStore } from '~~/src/stores/useElementalListsStore'

defineOptions({
  name: 'DrawerSidebarDrawerElementalLists',
})

const { state } = useElementalListsStore()
</script>

<template>
  <div flex flex-col max-h-full>
    <div px-2 />
    <div
      class="sticky py-0 top-0 z-10 w-full bg-gradient-to-b from-white via-white-75% to-transparent"
      :class="
        $style['no-scrollbar']
      "
      overflow-x-auto
    >
      <ElementalsListControls />
    </div>
    <div mt-2 flex flex-col gap-2 pb-4>
      <RecentElementals />
      <template v-for="(view, index) in state.viewsActives" :key="`view.${index}`">
        <ElementalViewComponent v-if="view && view.elementaltype !== ElementalTypeEnum.List" :view="view" />
      </template>
      <ElementalViewComponent v-if="state.viewsActives[ElementalTypeEnum.List] !== undefined" :view="state.viewsActives[ElementalTypeEnum.List]!" />
    </div>
  </div>
</template>

<style module lang="css">
 .no-scrollbar{
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
  &::-webkit-scrollbar {
    display: none;
    width: 0px;
    background: transparent;
  }
 }
</style>
